export { default } from './EditAutoDelivery.vue';